export const LANDING = '/';
export const SIGN_IN = '/signin';
export const HOME = '/';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const RESUME = '/resume';